import { render } from "./ColumnHeader.vue?vue&type=template&id=3c43f3a8"
import script from "./ColumnHeader.vue?vue&type=script&lang=js"
export * from "./ColumnHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__